import { InputForm } from "../types";

// CUSTOMER_COLUMNS is an array of objects that contains the column names and their width
export const CUSTOMER_COLUMNS = [
  {
    field: 'name',
    headerName: 'Name',
  },
  {
    field: 'email',
    headerName: 'Email',
  },
  {
    field: 'city',
    headerName: 'City',
    width: 150,
  },
  {
    field: 'state',
    headerName: 'State',
  },
  {
    field: 'inviteCode',
    headerName: 'Invite Code',
  },
  {
    field: 'invitationStatus',
    headerName: 'Onboarding Status',
  },
  {
    field: 'invitationExpiration',
    headerName: 'Onboarding Expires At',
  },
  {
    field: "createdAt",
    headerName: "Created At",
  },
]

export const INVITE_USER_FORM_INPUTS: InputForm[] = [
  {
    label: 'User email',
    id: 'email',
    type: 'email',
    required: true,
    placeholder: 'Insert the user email',
    grid: {
      xs: 12,
      sm: 12,
      md: 12,
    },
  },
];

export const CUSTOMER_INFO_FORM_INPUTS: InputForm[] = [
  {
    label: 'Company Name',
    id: 'name',
    type: 'text',
    required: true,
    placeholder: 'Insert the name of the customer company name',
    grid: {
      xs: 12,
      sm: 12,
      md: 12,
    },
    description: 'The name of the customer company'
  },
  {
    label: 'Point Of Contact First Name',
    id: 'contactFirstName',
    type: 'text',
    required: true,
    placeholder: 'Insert the first name of the point of contact',
    grid: {
      xs: 12,
      sm: 12,
      md: 6,
    },
  },
  {
    label: 'Point Of Contact Last Name',
    id: 'contactLastName',
    type: 'text',
    required: true,
    placeholder: 'Insert the last name of the point of contact',
    grid: {
      xs: 12,
      sm: 12,
      md: 6,
    },
  },
  {
    label: 'Point Of Contact Email',
    id: 'email',
    type: 'email',
    required: true,
    placeholder: 'Insert the email of the point of contact',
    grid: {
      xs: 12,
      sm: 12,
      md: 12,
    },
    description: 'The org owner will receive an invitation at this address'
  },
]

export const CUSTOMER_SUBSCRIPTION_FORM_INPUTS: InputForm[] = [
  {
    label: 'Subscription License Count',
    id: 'licenseCount',
    type:  'number',
    required: true,
    placeholder: '10',
    grid: {
      xs: 12,
      sm: 6,
      md: 6
    },
    description: 'The number of licenses on the mobile app for the customer company',
  },
  {
    label: 'Subscription Expiration Date',
    id: 'expiresAt',
    type: 'text',
    required: true,
    placeholder: '10/12/2024',
    mask: '99/99/9999',
    grid: {
      xs: 12,
      sm: 6,
      md: 6
    },
    description: 'The date for the subscription to expire',
  },
];

export const CUSTOMER_ACCESS_CREDENTIALS_FORM_INPUTS: InputForm[] = [

  {
    label: 'Point Of Contact Email',
    id: 'email',
    type: 'email',
    required: true,
    placeholder: 'Email of point of contact',
    grid: {
      xs: 12,
      sm: 12,
      md: 12,
    },
  },
  {
    label: 'New Password',
    id: 'password',
    type: 'password',
    required: true,
    placeholder: 'Please provide your password',
    grid: {
      xs: 12,
      sm: 12,
      md: 6,
    },
  },
  {
    label: 'Confirm Your New Password',
    id: 'confirmPassword',
    type: 'password',
    required: true,
    placeholder: 'Please confirm your password',
    grid: {
      xs: 12,
      sm: 12,
      md: 6,
    },
  },

]

export const CUSTOMER_CONFIRM_INFORMATION_FORM_INPUTS: InputForm[] = [
  {
    label: 'Company Name',
    id: 'name',
    type: 'text',
    required: true,
    placeholder: 'Insert the name of the customer company name',
    grid: {
      xs: 12,
      sm: 12,
      md: 6,
    },
  },
  {
    label: 'Point Of Contact Name',
    id: 'fullname',
    type: 'text',
    required: true,
    placeholder: 'Insert the full name of the point of contact',
    grid: {
      xs: 12,
      sm: 12,
      md: 6,
    },
  },
  {
    label: 'Point Of Contact Phone Number',
    id: 'phoneNumber',
    type: 'text',
    mask: '999-999-9999',
    required: true,
    placeholder: 'Insert the phone number of the point of contact',
    grid: {
      xs: 12,
      sm: 12,
      md: 6,
    },
  },
  {
    label: 'City',
    id: 'city',
    type: 'text',
    required: true,
    placeholder: 'Insert the name of the city',
    grid: {
      xs: 12,
      sm: 12,
      md: 6,
    },
  },
  {
    label: 'State',
    id: 'state',
    type: 'text',
    required: true,
    placeholder: 'Insert the name of the state',
    grid: {
      xs: 12,
      sm: 12,
      md: 6,
    },
  },
  {
    label: 'Zip Code',
    id: 'zip',
    type: 'text',
    required: true,
    placeholder: 'Insert the zipcode of the city',
    grid: {
      xs: 12,
      sm: 12,
      md: 6,
    },
  },
];
export const CUSTOMER_FILTER_INPUTS: InputForm[] = [
  {
    label: 'Name',
    id: 'name',
    type: 'text',
    required: false,
    placeholder: 'Insert name to filter',
    grid: {
      xs: 4,
      sm: 4,
      md: 4,
    },
  },
  {
    label: 'City',
    id: 'city',
    type: 'text',
    required: false,
    placeholder: 'Insert city name to filter',
    grid: {
      xs: 4,
      sm: 4,
      md: 4,
    },
  },
  {
    label: 'State',
    id: 'state',
    type: 'text',
    required: false,
    placeholder: 'Insert state to filter',
    grid: {
      xs: 4,
      sm: 4,
      md: 4,
    },
  },
  {
    label: 'Zip code',
    id: 'zip',
    type: 'text',
    required: false,
    placeholder: 'Insert zipcode to filter',
    grid: {
      xs: 4,
      sm: 4,
      md: 4,
    },
  },
];
